import { render, staticRenderFns } from "./SageConfirmPermission.vue?vue&type=template&id=492caf6c&"
import script from "./SageConfirmPermission.vue?vue&type=script&lang=js&"
export * from "./SageConfirmPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports